import { createUseStyles } from 'react-jss';
import { ITheme } from '../../components/theme';

type RuleNames =
  | 'form'
  | 'time'
  | 'text'
  | 'resend'
  | 'check'
  | 'mainBlock'
  | 'button'
  | 'img'
  | 'mainTitle'
  | 'img2'
  | 'img1'
  | 'emailText';

const PREFIX = 'VerifyCode';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>((theme: ITheme) => ({
  button: {
    marginTop: '25px',
    borderRadius: '10px',
    textTransform: 'none',
    background: 'black',
    fontSize: 20,
    '&:hover': {
      background: theme.grey,
    },
  },
  emailText: {
    color: theme.darkGreen,
  },
  mainTitle: {
    fontSize: 36,
    color: theme.darkGreen,
    fontFamily: theme.caslonDoric,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 375,
  },
  time: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.lightGreen,
  },
  text: {
    color: theme.grey,
    fontSize: 14,
    fontWeight: 600,
  },
  resend: {
    alignSelf: 'center',
    margin: '28px 0 11px',
  },
  check: {
    marginBottom: 15,
  },
  mainBlock: {
    display: 'flex',
    overflow: 'hidden',
    fontFamily: theme.helveticaNeue,
    height: '100vh',
    '& .Mui-disabled': {
      background: theme.hoverLightGreen,
      color: theme.darkGreen,
    },
  },
  img: {
    maxHeight: '100vh',
    backgroundSize: 'contain',
    width: '50vw',
    textAlign: 'center',
  },
  img1: {
    position: 'relative',
    zIndex: 0,
    top: -305,
    width: '100%',
  },
  img2: {
    position: 'relative',
    zIndex: 2222,
    top: 291,
  },
}), { name: PREFIX });
